import React from 'react';
import {
  Grid,
  Typography,
} from '@material-ui/core';
import commonStyles from '../styles';
import { validateFormInt1 } from '../../commonFunction/validations';

function InactiveOldCustomerThreshold(props) {
  const { division, setDivision, getComponent } = props;
  const baseClasses = commonStyles();

  const handleChange = (e) => {
    const val = e.target ? e.target.value : e;
    setDivision({ ...division, inactiveOldCustomerThresholdDays: val });
  };

  const validateInactiveOldCustomerThresholdDays = (value) => {
    const errors = validateFormInt1({
      minFloat: 1,
      maxFloat: 999,
    })(value);
    return errors.length > 0 ? ['入力内容が不正です'] : [];
  };

  const basicField = [
    {
      label: '挙動なし旧客判定日数',
      require: true,
      type: 'number',
      key: 'inactiveOldCustomerThresholdDays',
      state: division.inactiveOldCustomerThresholdDays,
      set: handleChange,
      validator: validateInactiveOldCustomerThresholdDays,
      width: '100%',
    },
  ];

  return (
    <>
      <Typography style={{ marginTop: 10, marginBottom: 10 }} className={baseClasses.title3}>
        挙動なし旧客
      </Typography>
      {basicField.map((data) => (
        <Grid key={data.key}>
          {getComponent(data)}
        </Grid>
      ))}
    </>
  );
}

export default InactiveOldCustomerThreshold;
